var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{staticClass:"overview-wrap",attrs:{"loading":false,"empty":false}},[_c('img',{staticClass:"contact-info-img",attrs:{"src":require("@/assets/images/contact_us.png")}}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }